/**
 * Cart: intercept Google Sheets xlsx export links so browsers treat them as downloads
 * (Content-Disposition: attachment) instead of navigating to a Sheets/viewer tab.
 * Uses capture-phase preventDefault + same-gesture programmatic <a> click.
 */
(function () {
  if (typeof window.__frGsCatalogDlBound !== "undefined") return;
  window.__frGsCatalogDlBound = true;

  var EXPORT_FALLBACK_XLSX =
    "https://docs.google.com/spreadsheets/d/1QrrnZkrH1Eu38hsSluV2c_KJpioG4PDVsmdgB9GOdNg/export?format=xlsx&gid=0";

  /** @returns {null|string} */
  function sheetsExportHref(href) {
    try {
      var u = new URL(href, window.location.href);
      if (!/^docs\.google\.com$/i.test(u.hostname)) return null;
      if (u.pathname.indexOf("/spreadsheets/d/") === -1) return null;
      if (u.pathname.indexOf("/export") === -1) return null;
      var fmt = (u.searchParams.get("format") || "").toLowerCase();
      if (fmt !== "xlsx" && !/[?&]format=xlsx(?:&|$)/i.test(u.search)) return null;
      return u.href;
    } catch (e) {
      return null;
    }
  }

  /** @returns {boolean} */
  function skip(ev) {
    return (
      ev.defaultPrevented ||
      ev.ctrlKey ||
      ev.metaKey ||
      ev.shiftKey ||
      ev.altKey ||
      (typeof ev.button === "number" && ev.button !== 0)
    );
  }

  /**
   * Must stay synchronous in the real click handling stack so the browser treats
   * this as a user-initiated navigation (attachment download).
   * @param {string} url
   */
  function triggerDownload(url) {
    var a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "Fraganta_Catalog.xlsx");
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    try {
      a.click();
    } finally {
      try {
        a.remove();
      } catch (e2) {}
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      if (skip(event)) return;

      var t = event.target;
      while (t && t.nodeType !== 1) {
        t = t.parentNode;
      }
      if (!t || !t.closest) return;

      var csvBtn = t.closest(".csv-download-example-link");
      var catalogA = t.closest("a.fr-apps-bulk-cat__a");

      var url = null;
      if (csvBtn) {
        url = EXPORT_FALLBACK_XLSX;
      } else if (catalogA && catalogA.href) {
        url = sheetsExportHref(catalogA.href);
      }

      if (!url) return;

      event.preventDefault();
      triggerDownload(url);
    },
    true
  );
})();
